export * from './utils';
export * from './key-value-persister';
export * from './memory-key-value-persister';
export * from './key-value-store-persister';
export * from './browser';
export * from './sql-key-value-store-persister';



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/datastore/persisters/index.js